import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-6">
            Prêt à commencer votre transformation ?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Rejoignez des milliers de personnes qui ont déjà atteint leurs objectifs fitness avec nos coachs experts
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/coachs')}
              className="font-medium rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 text-lg"
            >
              <i className="ri-search-line mr-2"></i>
              Trouver un coach
            </button>
            <button
              onClick={() => navigate('/devenir-coach')}
              className="font-medium rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-3 text-lg"
            >
              <i className="ri-user-add-line mr-2"></i>
              Devenir coach
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
            <div>
              <div className="text-3xl font-bold mb-2">500+</div>
              <div className="text-blue-100">Coachs certifiés</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">10k+</div>
              <div className="text-blue-100">Clients satisfaits</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">50k+</div>
              <div className="text-blue-100">Séances réalisées</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
